'use client';
import React, { useEffect, useState, useRef } from 'react';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from '@material-tailwind/react';

const ServicesOffered = () => {
    const [activeTab, setActiveTab] = useState('CustomAI');
    const [mounted, setMounted] = useState(false);
    const lastHash = useRef('');

    // Set initial tab and listen for hash changes
    const scrollToTabs = () => {
        const el = document.getElementById('service-tabs-test');
        if (el) {
            const offset = 100; // gap from top
            const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!mounted) return;
        
        lastHash.current = window.location.hash;
        const updateTabFromHash = () => {
            const hash = window.location.hash.replace('#', '');

            if (
                hash === 'CustomAI' ||
                hash === 'machinelearning' ||
                hash === 'dataanalysis' ||
                hash === 'predictiveanalytics' ||
                hash === 'naturallanguage' ||
                hash === 'computervision' ||
                hash === 'roboticprocess' ||
                hash === 'aiconsultation' ||
                hash === 'autonomousai' ||
                hash === 'lowcodeai' ||
                hash === 'agenticaisol' ||
                hash === 'retrievalaugmented' ||
                hash === 'vectordatabase' ||
                hash === 'datascience' ||
                hash === 'generativeconversationalai' ||
                hash === 'intelligentautomation' ||
                hash === 'aiintegration' ||
                hash === 'aicybersecurity'
            ) {
                setActiveTab(hash);
                scrollToTabs();
            }
        };
        updateTabFromHash();

        const interval = setInterval(() => {
            const currentHash = window.location.hash;
            if (currentHash !== lastHash.current) {
                lastHash.current = currentHash;
                updateTabFromHash();
            }
        }, 100);

        return () => clearInterval(interval);
    }, []);
    const data = [
        {
            label: 'Custom AI Solutions',
            value: 'CustomAI',
            title: 'Custom AI Solutions',
            desc: `We build AI that fits your business like a glove. There's no room for off-the-shelf stuff here. Whether you're looking to automate tasks, get smarter insights from your data, or something else entirely, we're here to make it happen. We work with folks in healthcare, finance, retail - you name it. Our goal is simple: use the latest AI to help you innovate, grow, and really connect with your customers. From the look and feel to the powerful tech under the hood, it's all custom-made for you.`,
            listingheading: 'Custom AI Solutions Involves',
            list: [
                'Recommendation engines',
                'Predictive intelligence tools',
                'Natural language processing applications',
                'Automating repetitive workflows',
                'Reengineering core business functions',
            ],
        },
        {
            label: 'Machine Learning Models',
            value: 'machinelearning',
            title: 'Machine Learning Models',
            desc: `Our machine learning services include building, training, and deploying models that deliver actionable insights, empowering businesses to make smarter decisions. Using advanced algorithms, we create systems that process vast datasets and deliver results aligned with your business KPIs, faster and more accurately.`,
            listingheading: 'Machine Learning Models Involves',
            list: [
                'Data preparation and management',
                'Model development and deployment',
                'Training and performance evaluation',
                'Continuous monitoring and tuning',
            ],
        },
        {
            label: 'Data Analysis and Processing',
            value: 'dataanalysis',
            title: 'Data Analysis and Processing',
            desc: `Extract meaningful insights with our end-to-end data analysis and processing services covers everything from data cleaning to real-time intelligence. We transform raw datasets into strategic assets using predictive modeling and analytics to enhance decision-making, customer experience, and product development.`,
            listingheading: 'Data Analysis and Processing Involves',
            list: [
                'Data strategy and consulting',
                'Business intelligence and reporting',
                'Data visualization and delivery of insights',
                'Customer analytics and personalization',
                'IoT and sensor data analytics',
                'Industry-specific analytics solutions',
            ],
        },
        {
            label: 'Predictive Analytics',
            value: 'predictiveanalytics',
            title: 'Predictive Analytics',
            desc: `Leverage machine learning-driven predictive analytics to stay ahead of the curve. We help you forecast trends, anticipate market changes, and make data-backed decisions that minimize risk and maximize growth.`,
            listingheading: 'Predictive Analytics Involves',
            list: [
                'Pattern and trend recognition',
                'Behavior Prediction',
                'Customer Segmentation',
                'Fraud Detection and Anomaly Tracking',
                'Smart Forecasting',
                'Demand Prediction',
            ],
        },
        {
            label: 'Natural Language Processing',
            value: 'naturallanguage',
            title: 'Natural Language Processing',
            desc: `Unlock human-like language understanding with our NLP services. From enhancing customer conversations to extracting key information from text, we deliver intelligent, real-time language solutions that boost personalization and responsiveness.`,
            listingheading: 'Natural Language Processing Involves',
            list: [
                'Text processing and entity extraction',
                'Statistical and rule-based NLP',
                'Linguistic modeling',
                'Spam detection systems',
                'Sentiment and intent analysis',
                'Speech recognition',
            ],
        },
        {
            label: 'Computer Vision',
            value: 'computervision',
            title: 'Computer Vision',
            desc: `Build real-time visual intelligence systems with our computer vision services. We transform how businesses analyze and act on image and video data, enabling smarter decisions through object recognition, image classification, and advanced scene understanding.`,
            listingheading: 'Computer Vision Involves',
            list: [
                'Development using OpenCV, TensorFlow, etc.',
                'Cloud vision integration (AWS, Azure, Google Cloud)',
                'Real-time video monitoring and analytics',
                'Object and face detection',
                'Image categorization',
                'Scene identification and analysis',
            ],
        },
        {
            label: 'Robotic Process Automation',
            value: 'roboticprocess',
            title: 'Robotic Process Automation',
            desc: `Drive efficiency and reduce manual workloads with intelligent RPA services. We automate repetitive tasks across departments, improving operational performance, reducing errors, and cutting costs.Our RPA solutions integrate seamlessly with your existing systems to ensure smooth, scalable automation without disruption.`,
            listingheading: 'Robotic Process Automation Involves',
            list: [
                'Custom solution development and system integration',
                'Bot configuration and deployment',
                'Ongoing support and management',
            ],
        },
        {
            label: 'AI Consultation',
            value: 'aiconsultation',
            title: 'AI Consultation',
            desc: `Our AI/ML consultants help you identify, evaluate, and implement AI opportunities across your organization. From strategy to execution, we offer expert guidance that ensures your AI investments are aligned with your business goals and deliver measurable value.`,
            listingheading: 'AI Consultation Involves',
            list: [
                'Helping organizations pinpoint high-impact AI use cases that drive transformation, increase operational efficiency, and accelerate innovation.',
            ],
        },
        {
            label: 'Autonomous AI Agents',
            value: 'autonomousai',
            title: 'Autonomous AI Agents',
            desc: `We design AI agents that operate independently—making decisions, taking action, and learning from outcomes. These agents streamline operations in customer service, logistics, and support functions by reducing the need for manual intervention. Our implementations often leverage multi-agent systems (MAS) for collaborative task execution in dynamic environments.`,
            listingheading: '',
            list: [
                'Autonomous task execution across workflows',
                'MAS (Multi-Agent Systems) for distributed decision-making',
                'Ideal for operations, support, and supply chain automation',
            ],
        },
        {
            label: 'Low-Code/No-Code AI Platforms',
            value: 'lowcodeai',
            title: 'Low-Code/No-Code AI Platforms',
            desc: `Empower your teams to build and deploy AI models with minimal technical effort. Our low-code/no-code AI solutions drastically reduce development cycles and make AI accessible to business analysts, product managers, and non-engineers.`,
            listingheading: '',
            list: [
                'Democratizes AI for non-technical users',
                'Reduces go-to-market time for ML features',
                'Supports custom workflows with pre-built AI components',
            ],
        },
        {
            label: 'Agentic AI Solutions',
            value: 'agenticaisol',
            title: 'Agentic AI Solutions',
            desc: `Agentic AI systems are purpose-built for autonomous, intelligent behavior—without constant oversight. These solutions are used in customer support bots, security workflows, and intelligent process automation where reasoning, memory, and self-directed action are essential.`,
            listingheading: '',
            list: [
                'Self-directed agents with autonomous decision-making',
                'Supports long-term memory, reasoning, and task chaining',
                'Suitable for complex workflows in devops, business ops, and analytics',
            ],
        },
        {
            label: 'Retrieval-Augmented Generation (RAG) & Agentic RAG',
            value: 'retrievalaugmented',
            title: 'Retrieval-Augmented Generation (RAG) & Agentic RAG',
            desc: `RAG enhances large language models by retrieving real-time, relevant knowledge from databases or APIs before generating a response, ensuring context-rich outputs. Agentic RAG takes this further by embedding autonomous agents into the retrieval process, allowing them to dynamically select and refine retrieval strategies based on task goals.`,
            listingheading: '',
            list: [
                'Enables real-time, domain-specific, and grounded LLM responses',
                'Reduces hallucination in enterprise chatbots and assistants',
                'Ideal for knowledge management, compliance, and research tools',
            ],
        },
        {
            label: 'Vector Database Integration',
            value: 'vectordatabase',
            title: 'Vector Database Integration',
            desc: `We implement high-performance vector databases like FAISS, Milvus, and Chroma to power semantic search, chatbot memory, and recommendation engines. These databases enable similarity search and clustering based on embeddings - essential for working with unstructured data like text, images, or audio.`,
            listingheading: '',
            list: [
                'Supports fast and scalable similarity search',
                'Foundation for chatbots, semantic retrieval, and RAG pipelines',
                'Integrates with LangChain, Pinecone, and LLM backends',
            ],
        },
        {
            label: 'Data Science & Predictive Analytics',
            value: 'datascience',
            title: 'Data Science & Predictive Analytics',
            desc: `We build advanced machine learning models that help you see what's coming - and act faster. From building scalable data pipelines to time-series forecasting and real-time risk modeling, our solutions are designed for decision-makers who rely on accuracy at scale.`,
            listingheading: '',
            list: [
                'Predictive modeling for sales, health, and finance',
                'Real-time anomaly detection with statistical ML',
                'Time-series forecasting for operations and demand',
            ],
        },
        {
            label: 'Generative & Conversational AI',
            value: 'generativeconversationalai',
            title: 'Generative & Conversational AI',
            desc: `Move beyond basic chatbots with next-gen AI experiences. We develop custom LLMs, multilingual NLP systems, and RAG pipelines that deliver meaningful, context-rich interactions, whether it's for customer service, e-learning, or interactive media.`,
            listingheading: '',
            list: [
                'Natural language understanding and semantic parsing',
                'Custom LLM development with fine-tuned responses',
                'Retrieval-Augmented Generation (RAG) and Agentic RAG workflows',
                'Conversational AI and chatbots',
            ],
        },
        {
            label: 'Intelligent Automation & AI Agents',
            value: 'intelligentautomation',
            title: 'Intelligent Automation & AI Agents',
            desc: `From RPA to Auto-GPT-style autonomous agents, we design systems that don't just automate tasks. They chain decisions intelligently. Whether it's handling support queries or managing backend workflows, our AI agents learn, adapt, and execute with minimal oversight.`,
            listingheading: '',
            list: [
                'Robotic Process Automation for repetitive tasks',
                'Agentic AI and autonomous decision-making pipelines',
                'Continuous learning agents for adaptive task chains',
            ],
        },
        {
            label: 'AI Platforms Integration',
            value: 'aiintegration',
            title: 'AI Platforms Integration',
            desc: `Accelerate your AI roadmap with rapid deployment options. From no-code AI builder platforms to semantic search powered by vector databases, we help you integrate AI capabilities into existing systems - fast, securely, and at scale.`,
            listingheading: '',
            list: [
                'Low-code/no-code AI development environments',
                'End-to-end pipelines using LangChain and Pinecone',
                'Semantic search with FAISS, Chroma, Milvus vector DBs',
            ],
        },
        {
            label: 'AI-Powered Cybersecurity',
            value: 'aicybersecurity',
            title: 'AI-Powered Cybersecurity',
            desc: `Stop threats before they escalate. Our ML-based security frameworks proactively detect and mitigate fraud, anomalies, and zero-day exploits. This ensures your digital infrastructure stays one step ahead of evolving risks.`,
            listingheading: '',
            list: [
                'AI-enabled intrusion detection and behavioral analysis',
                'Real-time anomaly detection and pattern recognition',
                'Fraud detection systems for financial and e-commerce platforms',
            ],
        },
    ];

    return (
        <div className="section-py bg-aiml-service-offer">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-5">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white">Services Offered</h2>
                        <p className="text-white mb-0 fw-600 dark:text-[#D7DEE5]">
                            Our cutting-edge digital solutions and services have been helping businesses across the world to
                            mitigate modern business challenges with a modern digital-first approach.
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div id="service-tabs-test" className="lg:col-span-12 grid">
                        <Tabs
                            value={activeTab}
                            key={activeTab}
                            orientation="vertical"
                            className="service-tabs-header"
                            animate={{ mount: false, unmount: false }}
                        >
                            <div className="flex flex-col md:flex-row lg:flex-row w-full lg:h-[550px] md:h-[550px] h-auto">
                                <TabsHeader className="service-offered-tabs">
                                    {data.map(({ label, value }) => (
                                        <Tab
                                            className="service-tab-size"
                                            activeClassName="service-active-li"
                                            key={value}
                                            value={value}
                                        >
                                            {label}
                                        </Tab>
                                    ))}
                                </TabsHeader>
                                <TabsBody className="services-offered-bg transition-none">
                                    {data.map(({ value, title, desc, list, listingheading }) => (
                                        <TabPanel
                                            key={value}
                                            value={value}
                                            className="transition-none p-7 service-offered-listing"
                                        >
                                            <h2 className="text-primary mb-4">{title}</h2>
                                            <p className="fs-md text-[#D7DEE5] mb-4">{desc}</p>
                                            <p className="text-white fw-600 mb-4">{listingheading}</p>
                                            <ul className="list-disc list-inside mb-4">
                                                {list.map((item, index) => (
                                                    <li className="fs-md text-[#D7DEE5] mb-2" key={index}>
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        </TabPanel>
                                    ))}
                                </TabsBody>
                            </div>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ServicesOffered;
